var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"altodiv"},[_c('b-alert',{attrs:{"show":"","dismissible":""}},[_vm._v(" Contenido en programación. ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }